import actionTypes from "../actionTypes";

export const getMyDraftsAction = (data, count) => ({
  type: actionTypes.manageTypes.GET_MY_DRAFTS,
  payload: data,
  count: count,
});
export const resetMyDraftsCountAction = (data, count) => ({
  type: actionTypes.manageTypes.RESET_MY_DRAFTS_COUNT,
  payload: data,
  count: count,
});
export const getPublishedByMeAction = (data, count) => ({
  type: actionTypes.manageTypes.GET_PUBLISHED_BY_ME,
  payload: data,
  count: count,
});
export const getPublishedByOthersAction = (data, count) => ({
  type: actionTypes.manageTypes.GET_PUBLISHED_BY_OTHERS,
  payload: data,
  count: count,
});
export const getManageTranscriptionAction = (data, count) => ({
  type: actionTypes.manageTypes.GET_TRANSCRIPTION_DETAILS,
  payload: data,
  count: count,
});
export const deleteShotclassLoaderAction = (data, count) => ({
  type: actionTypes.manageTypes.DELETE_SHOTCLASS_LOADER,
  payload: data,
  count: count,
});

export const getClassDetailsByIdAction = (data) => ({
  type: actionTypes.manageTypes.GET_CLASS_DETAILS_BY_ID,
  payload: data,
});
export const setGetLanguagesLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_GET_LANGUAGES_LOADER,
  payload: data,
});
export const setGetTrainingTypesLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_GET_TRAININGS_LOADER,
  payload: data,
});
export const setGetShotclassTagLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_GET_SHOTCLASS_TAG_LOADER,
  payload: data,
});
export const setIsShotclassNameExistLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_IS_SHOTCLASS_NAME_EXIST_LOADER,
  payload: data,
});
export const setSaveAsADraftLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_SAVE_AS_A_DRAFT_LOADER,
  payload: data,
});
export const setGetUserGroupsLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_GET_USER_GROUPS_LOADER,
  payload: data,
});
export const setShotclassPublishLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_SHOTCLASS_PUBLISH_LOADER,
  payload: data,
});
export const setGetYoutubeVideosLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_GET_YOUTUBE_VIDEOS_LOADER,
  payload: data,
});
export const setGetOnlineCoursesLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_GET_ONLINE_COURSES_LOADER,
  payload: data,
});
export const setGetSlidesharesLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_GET_SLIDESHARES_LOADER,
  payload: data,
});

export const setAddTrainingLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_ADD_TRAINING_LOADER,
  payload: data,
});
export const setDeleteTrainingLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_DELETE_TRAINING_LOADER,
  payload: data,
});

export const setAddBulkUploadCSVLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_BULK_UPLOAD_CSV_LOADER,
  payload: data,
});
export const setUploadQuizImagesLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_UPLOAD_QUIZ_IMAGES_LOADER,
  payload: data,
});
export const setDeleteQuizImagesLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_DELETE_QUIZ_IMAGES_LOADER,
  payload: data,
});

export const setGetTranscriptionDataLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_GET_TRANSCRIPTION_DATA_LOADER,
  payload: data,
});
export const setAddTranscribeTagLoaderAction = (data) => ({
  type: actionTypes.manageTypes.SET_ADD_TRANSCRIBE_TAG_LOADER,
  payload: data,
});

export const setUpdateVideoListAction = (data) => ({
  type: actionTypes.manageTypes.SET_UPDATE_VIDEO_LIST,
  payload: data,
});
export const setShowVideoUploadListPanelAction = (data) => ({
  type: actionTypes.manageTypes.SET_SHOW_VIDEO_UPLOAD_LIST_PANEL,
  payload: data,
});
